import React, { useState, createContext, useEffect, useRef } from "react";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from "firebase/firestore";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setCurrentUser(user)
            setLoading(false);
        });
        return unsubscribe;
    }, []);

    // Función para obtener los datos del usuario desde Firestore
    const fetchUserData = async () => {
        if (currentUser) {
            // const user2 = currentUser.providerData[0]
            const userDocRef = doc(db, 'users', currentUser.uid);
            const userDocSnap = await getDoc(userDocRef);

            if (userDocSnap.exists()) {
                const userDatax = userDocSnap.data();
                setUserData(userDatax)
            }
        }
    };
    // Llama a fetchUserData cuando el componente se monta
    useEffect(() => {
        fetchUserData();
    }, [currentUser]); // Depende de currentUser para actualizar si cambia

    return (
        <AuthContext.Provider value={{
            currentUser,
            setCurrentUser, loading, userData, fetchUserData
        }}>
            {children}
        </AuthContext.Provider>
    )
}